
import Vue from "vue";
import ProjectsList from "@/components/ProjectsList.vue";
import gameProjectsData from "@/data/GameProjectsData";

export default Vue.extend({
  name: "GameProjects",
  components: {
    ProjectsList,
  },
  data: function () {
    return {
      projects: gameProjectsData,
    };
  },
  async created() {
    try {
      const res = await fetch("/api/projects.php");
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          this.projects = data;
        }
      }
    } catch (e) {
      console.warn("Could not fetch from API, using static data", e);
    }
  }
});
